// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyFeature_container__2wuxg","title":"KeyFeature_title__3AS4F","content":"KeyFeature_content__1FPwb"};